// THIS FILE IS GENERATED BY 'npm run set-env-variables'

export const environment = {
  production: true,

  // Configuration/Feature-switches:
  envName: '',
  useServiceWorker: true,
  useOffers: true,
  useQandAs: true,
  useQandASearch: true,
  useRegionPerLocale: false,
  useFeedbackPrompt: false,

  // Configuration of content
  localeLanguage: 'en',
  localeDir: 'ltr',
  localeAlternatives: 'ar:العربية, en:English, es:Español, fr:Français, *:Other...',
  localeAlternativesExplanation: '* Translations via Google Translate',
  appName: 'Baphalali Eswatini Red Cross Society',
  appLogoUrl: 'https://redcross.org.sz/wp-content/uploads/2024/07/iso2_sz.jpg',
  mainPageHeader: 'Hi! You can edit me',
  mainPageIntroduction: '\n This web app is made to give helpful information (HIA) about frequently asked questions (FAQ). Please select your FAQ below',
  mainPageNotification: 'Hi, welcome on the main page of the Helpful-Information App of Baphalali Eswatini Red Cross!',
  pageAbout: '\n Also test test \n another one',
  pagePrivacy: '\n',
  mainFooter: '**Urgent matters?**  \n \n Toll free line: 7602 \n Speak out email: speakout@redcross.org.sz \n Link to our website: https://redcross.org.sz/',
  errorHeader: 'Data Unavailable',
  errorMessage: 'Reach out to us at: ',
  errorContactUrl: 'https://github.com/rodekruis/HIA_Eswatini_test',
  errorRetry: 'Try again?',

  // Regions:
  regionConfig: '',
  regions: 'dm, hs, ca, sg',
  regionsLabels: 'Disaster Response/Community programs, Health Services, Community Alert, Safe Guarding',
  regionsSheetIds: '1YMa1hlhQCKroCtQm2bJMqNDZ2Jf8u_vfERyP-PTAK8o, 1PTt7X2JLGAnIztTa65yZZrWuaiYzenhhfJpqmtU2bcE, 19d5ZiVAci43r34K5elFS7QkJ7q6eFhDQMjfBMLtrJMw, 1q6Es8dfGuVanIMPS_QoWjnGbJ2WxXv_m6oTICm9SgxI',

  // Third-party tokens:
  google_sheets_api_key: 'AIzaSyDBybL25MdQAOoeSBp4AByhXUkqikSYGiI',
  google_sheets_api_url: 'https://sheets.googleapis.com/v4/spreadsheets',
  matomoConnectionString: '',
  appInsightsConnectionString: '',
};
